
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/OUUJV",
      function () {
        return require("private-next-pages/goal/[goalSlug]/OUUJV.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/OUUJV"])
      });
    }
  